import { useRouter } from 'next/router';
import React from 'react';
import DashboardPage from '../../components/Dashboard/DashboardPage';
import Profile from '../../components/Dashboard/Profile';
import withApollo from '../../lib/withApollo';

const ProfilePage = () => {
  const router = useRouter();

  const { open } = router.query;
  return <DashboardPage open={open} label="profile" content={<Profile />} />;
};

export default withApollo(ProfilePage);
